import { forwardRef, type JSX, type ReactNode, type SelectHTMLAttributes } from 'react';
import clsx from 'clsx';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import { FilterField } from './FilterField';

interface FilterSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  id: string;
  containerClassName?: string;
  children: ReactNode;
}

/**
 * FilterSelect wraps a native select with the shared dashboard filter styling.
 */
export const FilterSelect = forwardRef<HTMLSelectElement, FilterSelectProps>(function FilterSelect(
  { label, id, containerClassName, className, children, ...rest },
  ref,
): JSX.Element {
  return (
    <FilterField label={label} htmlFor={id} className={containerClassName}>
      <div className="relative">
        <select
          id={id}
          ref={ref}
          className={clsx(
            'w-full appearance-none rounded-xl border border-surface-subtle bg-white px-4 py-3 pr-14 text-base shadow-sm transition focus:border-brand-primary focus:outline-none focus:ring-2 focus:ring-brand-primary/30 md:text-sm',
            className,
          )}
          {...rest}
        >
          {children}
        </select>
        <span
          aria-hidden="true"
          className="pointer-events-none absolute inset-y-0 right-4 flex items-center pr-2 text-brand-primary/70"
        >
          <ChevronDownIcon className="h-4 w-4" />
        </span>
      </div>
    </FilterField>
  );
});

FilterSelect.displayName = 'FilterSelect';
